
import { defineComponent, computed, toRefs, PropType } from "vue";
import "./card.scss";

export default defineComponent({
  name: "adm-card",
  inheritAttrs: false,
  emits: ["clickMedia"],
  props: {
    variant: {
      type: String as PropType<"horizontal" | "vertical">,
      default: "vertical",
    },
    mediaSrc: {
      type: String,
      default: null,
    },
    mediaStyle: {
      type: Object as PropType<Partial<CSSStyleDeclaration>>,
      default: () => ({}),
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { mediaSrc, mediaStyle, variant, bordered } = toRefs(props);

    const classes = computed(() => [
      "adm-card",
      `adm-card--variant-${variant.value}`,
      { "adm-card--bordered": !!bordered.value },
    ]);

    const mediaStyleObject = computed(() => ({
      backgroundImage: `url(${mediaSrc.value})`,
      ...mediaStyle.value,
    }));

    return {
      classes,
      mediaStyleObject,
    };
  },
});
